/**
 * Deep clone of context data (working copies, persistence payloads).
 *
 * Contexts are plain JSON structures, so structuredClone is safe and fast.
 * Do NOT use omegagrid utils.cloneDeep for contexts: it copies arrays
 * shallowly, so nested array elements (filters, plot_bands, items, ...)
 * would stay shared with the source - and when the source is a frozen
 * store snapshot, editing such a "copy" throws in dev.
 */
export const cloneContext = <T>(value: T): T =>
	value == null ? value
	: typeof structuredClone === 'function' ? structuredClone(value)
	: JSON.parse(JSON.stringify(value));
